import { useContext } from 'react'
import debounce from 'lodash/debounce'
import { getSessionID } from 'utils/tracking'
import NativeAuthContext from 'components/NativeAuth'
import { captureException } from 'lib/sentry'
import { PAGE_TYPES } from 'utils/constants'
import { stripPrefix } from 'utils/routing'

const trackPageView = debounce(() => {
  try {
    window._satellite.track('pageview')
  } catch (e) {}
}, 1500)

export default () => {
  const authContext = useContext(NativeAuthContext)
  const { user, digitalDataPopulated, setDigitalDataPopulated } = authContext || {}

  if (typeof window === 'undefined') {
    return {
      digitalData: {
        push: () => {}
      },
      trackPage: () => {},
      trackPageView: () => {}
    }
  }

  window.digitalData =
    window.digitalData ||
    new (function () {
      this.push = function (value) {
        try {
          for (var x in value) {
            if (typeof this[x] == 'undefined') this[x] = value[x]
            else Object.assign(this[x], value[x])
          }
        } catch (e) {}
      }
    })()

  const trackPage = ({ pageHierarchy, pageNotFound }) => {
    try {
      if (!authContext) return

      const hash = location.hash.substr(1)
      window.digitalData.push({
        page: {
          pageUrl: location.pathname,
          pageFullUrl: location.hostname + location.pathname + location.search + location.hash,
          virtualUrl: null,
          pageTitle: document.title,
          pageType: pageNotFound ? '404' : PAGE_TYPES[stripPrefix(location.pathname)] || 'other',
          pageHierarchy: pageHierarchy
            ? pageHierarchy
            : location.pathname
                .split('/')
                .concat(hash ? [hash] : [])
                .filter(s => s.length)
                .reduce((acc, s, i) => ({ ...acc, [`level${i + 1}`]: s }), {})
        },
        session: {
          sessionId: getSessionID(),
          loginInfo: {
            loginStatus: user ? 'logged-in' : 'logged-out'
          },
          softVerifyInput: localStorage.softVerifiedUser ? 'true' : 'false'
        }
      })

      trackPageView()
      if (!digitalDataPopulated && window.digitalData.page) {
        setDigitalDataPopulated(true)
      }
    } catch (e) {
      console.log(e)
      captureException(e)
    }
  }

  return { digitalData: window.digitalData, trackPage, trackPageView, digitalDataPopulated }
}
